<div class="page mb-0">
  <div class="container-fluid p-0">
    <div class="breadcrumb-generic breadcrumb-generic--overlay" style="background-image: url('./assets/images/bg_contact-us.jpg');">
      <div class="container-sm">
        <h1 class="breadcrumb-generic__title">Contatti</h1>
      </div>
    </div>
  </div>
  <div class="page-content contact-us">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-3" [ngClass]="{'col-lg-12': hasWtgNetwork}">
          <div class="e-title e-title__with-divider">
            <h2 class="h2">{{(hasGeoNetwork) ? 'Le nostre sedi' : 'Sede'}}</h2>
            <hr class="hr hr--heavy hr--brand hr--title mb-2" [ngClass]="{'w-100': hasGeoNetwork}">
          </div>
        </div>
        <div class="col-12 col-lg-9">
         <!-- <div *ngIf="hasGeoNetwork && (hasContacts$ | async)" class="contact-us__content">
            <p [innerHTML]="contacts$ | async"></p>
          </div>-->
          <div *ngIf="hasGeoNetwork && agenciesInfo && agenciesInfo?.length >0" class="contact-us__list">
            <div class="contact-us__filial" *ngFor="let agency of agenciesInfo" [ngClass]="{'contact-us__filial--row' : agenciesInfo?.length > 1}">
              <!-- <app-filial-banner [filial]="filial"></app-filial-banner> -->
              <div>
                <ng-container *ngTemplateOutlet="filiali; context: {filial: agency}"></ng-container>
              </div>

            </div>
          </div>
          <div *ngIf="agencyInfo" class="row">
            <div *ngIf="agencyInfo.address && agencyInfo.city && agencyInfo.latitude && agencyInfo.longitude" class="col-4">
              <a target="_blank" href="https://www.google.it/maps?q={{agencyInfo.address}},{{agencyInfo.city}}&ll={{agencyInfo.latitude}},{{agencyInfo.longitude}}&z=14">
                <img alt="map"
                     class="img img-fluid"
                     src="{{mapsBaseUrl}}{{agencyInfo.latitude}},{{agencyInfo.longitude}}&amp;key={{mapsKey}}">
              </a>
            </div>
            <div class="col-8">
              <h3 *ngIf="agencyInfo.denomination">{{agencyInfo.denomination}}</h3>
              <h5 *ngIf="agencyInfo.businessName">{{agencyInfo.businessName}}</h5>
              <h6 *ngIf="agencyInfo.address || (agencyInfo.city && agencyInfo.province)">
                <span>{{agencyInfo.address}}</span><br>
                <span *ngIf="agencyInfo.city && agencyInfo.province">{{agencyInfo.city}} ({{agencyInfo.province}})</span>
              </h6>
              <p *ngIf="agencyInfo.tel1">Recapito tel.: <a href="tel:{{agencyInfo.tel1}}">{{agencyInfo.tel1}}</a></p>
              <p *ngIf="agencyInfo.tel2">Altro recapito tel.: <a href="tel:{{agencyInfo.tel2}}">{{agencyInfo.tel2}}</a></p>
              <p *ngIf="agencyInfo.email1">Email: <a href="mailto:{{agencyInfo.email1}}">{{agencyInfo.email1}}</a></p>
              <p *ngIf="agencyInfo.email2">Altra Email: <a href="mailto:{{agencyInfo.email2}}">{{agencyInfo.email2}}</a></p>
              <p *ngIf="agencyInfo.openingTimes">Orari di apertura : {{agencyInfo.openingTimes}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #filiali let-filial="filial">
  <div class="row contact-filials">
    <div class="col-12 col-md-4">
      <a [href]="getMapOpenUrl(filial)"
         target="_blank"
         *ngIf="filial.latitude && filial.longitude" >
        <img class="img img-fluid" alt="map" [src]="getMapImageUrl(filial)">
      </a>
    </div>
    <div class="col-12 col-md-8">
      <h5 *ngIf="filial.denomination">{{filial.denomination}}</h5>
      <h6>{{filial.address}}<br>{{filial.cap}} {{filial.city}} {{filial.province}}</h6>
      <span *ngIf="filial.tel1">Telefono: <a [href]="'tel:' + filial.tel1">{{filial.tel1}}</a></span>
      <span *ngIf="filial.tel2">Altro recapito tel.: <a href="tel:{{filial.tel2}}">{{filial.tel2}}</a></span>
      <span *ngIf="filial.fax">Fax: <a [href]="'tel:' + filial.tel1">{{filial.tel1}}</a></span>
      <span *ngIf="filial.email1">Email: <a [href]="'mailto:' + filial.email1">{{filial.email1}}</a></span>
      <span *ngIf="filial.email2">{{filial.id === 14802 ? 'Pec' : 'Altra Email'}}: <a [href]="'mailto:' + filial.email2">{{filial.email2}}</a></span>
      <div class="contact-filials__text">
        <p *ngIf="filial.openingTimes" >Orari di apertura :{{filial.openingTimes}}</p>
      </div>
    </div>
  </div>
</ng-template>
